import React from "react";
import styled, { css } from "styled-components";

const ProductPriceStyles = styled.div`
  ${({ ...props }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-top: 32px;
    .price {
      display: grid;
      grid-template-columns: auto auto;
      column-gap: .5rem;
    }
    .price--type {
      grid-column: span 2;
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 1.1;
    }
    .price--price {
      line-height: 1.25;
      font-size: 2rem;
      font-weight: bold;
      color: ${props.theme.colors.primary}
    }
    .price--info {
      font-weight: bold;
      max-width: 7rem;
    }
  `}
`;

export const ProductPrice = ({ hirePrice, buyPrice }) => {
  return (
    <ProductPriceStyles>
      {hirePrice?.priceOnApplication && (
        <div className="price">
          <span className="price--type">
            Hire from
          </span>
          <span className="price--price">
            POA
          </span>
        </div>
      )}
      {!hirePrice?.priceOnApplication && hirePrice?.price && (
        <div className="price">
          <span className="price--type">
            Hire from
          </span>
          <span className="price--price">
            £{hirePrice.price.toFixed(2)}
          </span>
          <span className="price--info">
            {hirePrice.info} ex. VAT
          </span>
        </div>
      )}
      {buyPrice?.priceOnApplication && (
        <div className="price">
          <span className="price--type">
            Buy from
          </span>
          <span className="price--price">
            POA
          </span>
        </div>
      )}
      {!buyPrice?.priceOnApplication && buyPrice?.price && (
        <div className="price">
          <span className="price--type">
            Buy from
          </span>
          <span className="price--price">
            £{buyPrice.price.toFixed(2)}
          </span>
          <span className="price--info">
            {buyPrice.info} ex. VAT
          </span>
        </div>
      )}
    </ProductPriceStyles>
  );
};
